import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { Dispatch, Image, State } from "../types";
import "../styles.scss";

type Props = Readonly<{
  dispatch: Dispatch;
  images: ReadonlyArray<Image>;
  state: State;
}>;


export const ReadingPagination = (
  {
    state, 
    images, 
    dispatch
  }: Props) => {
  

  const [find, setFind] = useState("");
  const [replace, setReplace] = useState("");
  const [replacedInstances, setReplacedInstances] = useState(0);
  const [commonReplacedCharacters, setCommonReplacedCharacters] = useState("§");
  
  const [modal, setModal] = useState(false);

  const toggle = () => {
    // Unselect block or draft.js editor will retain focus and prevent dialog from being used
    dispatch({
      blockId: undefined,
      type: "MARK BLOCK ACTIVE",
    });
    setModal(!modal);
  }
  
  useEffect(()=>{
      const storedCommonChars = window.localStorage.getItem("gg-find-replace-chars");
      if (storedCommonChars) {
        setCommonReplacedCharacters(storedCommonChars);
      } 
  }, []) 

  return (
    <div className="reading-pagination">
      <Pagination aria-label="Job list navigation">
        <PaginationItem disabled={state.currentPage === 0}>
          <PaginationLink
            href="#"
            onClick={e => {
              e.preventDefault();
              dispatch({ 
                up:false,
                type: "PAGINATE",
              });
            }}
            previous
            title="Previous"
          />
        </PaginationItem>
        <PaginationItem className="flex-fill text-center " disabled>
          <PaginationLink className="text-dark" href="#">
            Pages {(state.currentPage * state.pageSize) + 1} - { ((state.currentPage + 1) * state.pageSize) + 1 > images.length ? images.length : ((state.currentPage + 1) * state.pageSize) } of { images.length }
          </PaginationLink>
        </PaginationItem>
        <PaginationItem disabled={(state.currentPage+1) * state.pageSize > images.length}>
          <PaginationLink
            href="#"
            onClick={e => {
              e.preventDefault();    
              dispatch({ 
                up:true,
                type: "PAGINATE",
              });
            }}
            next
            title="Next"
          />
        </PaginationItem>
      </Pagination>
      <Button
        onClick={toggle}
        style={{
          position:"absolute",
          right:7
        }}
      >
        Find & Replace
      </Button>
      <Modal
        isOpen={modal} 
        toggle={toggle}
      >
        <ModalHeader toggle={toggle}>Find and replace</ModalHeader>
        <ModalBody>
          <div>
            <div style={{position:"relative"}}>
              <span>Find</span>
              {!!state.substringInstances && <span style={{position:"absolute", right:5}}>Matches: {state.substringInstances}</span>}
            </div>
            <Input
                value={find}
                
                onChange={x => {
                  dispatch({
                    type:"COUNT SUBSTRINGS",
                    substring: x.target.value
                  })
                  setFind(x.target.value)
                }}
                type="text"
            />
          </div>
          <div>
          <span>Replace</span>
            <Input
                value={replace}
                onChange={x => {
                  setReplace(x.target.value)
                }}
                type="text"
            />
          </div>
          <div style={{marginTop:10}}>
            <span style={{marginRight:10}}>
              Common Symbols
            </span>
            <span>
            <Input
                value={commonReplacedCharacters}
                onChange={x => {
                  window.localStorage.setItem("gg-find-replace-chars", x.target.value);
                  setCommonReplacedCharacters(x.target.value)
                }}
                type="text"
            />
            </span>
          </div>
        </ModalBody>
        <ModalFooter>
          {!!replacedInstances && (<span style={{color:"#0600bd", flex:1}}>Replaced {replacedInstances} occurences!</span>)}
          <Button
            disabled={!find || !replace || !state.substringInstances}
            onClick={async () => {
              const replaced = state.substringInstances;
              await dispatch({
                type:"REPLACE SUBSTRINGS",
                substring: find,
                replacement:replace
              })
              setReplacedInstances(replaced)
              setTimeout(() => setReplacedInstances(0), 2000);
            }}
          >
            Replace
          </Button>
        </ModalFooter>  
      </Modal>
    </div>
  );
};